export { hideEmail as default };
async function hideEmail(email) {
  const [username, domain] = email.split("@");
  const maskedUsername = username.slice(0, 2);
  // const maskedPart = "*".repeat(username.length - 2);
  const maskedPart = "*".repeat(4);
  const maskedEmail = `${maskedUsername}${maskedPart}@${domain}`;
  return maskedEmail;
}

